import { useEffect } from 'react';
import { clearSnippet } from '@codemirror/autocomplete';

const EVENT_NAME = 'CodeEditorUpdateValue';

export function useValueUpdater(editor, value) {
    useEffect(() => {
        function handler({ detail }) {
            const { state, dispatch } = editor;

            if (detail !== state.doc.toString()) {
                const changes = {
                    from: 0,
                    to: state.doc.length,
                    insert: detail
                };
                dispatch(state.update({ changes }));
                clearSnippet(editor);
            }
        }

        if (value) {
            handler({ detail: value });
        }

        document.addEventListener(EVENT_NAME, handler);
        return () => document.removeEventListener(EVENT_NAME, handler);
    }, [editor, value]);
}
